import { render, staticRenderFns } from "./houseStatistical.vue?vue&type=template&id=56a892fb&"
import script from "./houseStatistical.vue?vue&type=script&lang=js&"
export * from "./houseStatistical.vue?vue&type=script&lang=js&"
import style0 from "./houseStatistical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports